import ResetPasswordForm from './ResetPasswordForm';
import ResetPassword from './ResetPassword';

export { ResetPasswordForm, ResetPassword };
